var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeA12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 32,
    rx: 6,
    fill: "#FBC115"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00903 24L11.153 7.2H14.609L20.753 24H17.489L16.145 20.112H9.59303L8.22503 24H5.00903ZM10.433 17.712H15.305L12.857 10.728L10.433 17.712ZM24.0146 24V10.704L21.2546 11.352V9L25.3106 7.2H27.2066V24H24.0146ZM30.056 24V21.768C31.08 20.92 32.072 20.08 33.032 19.248C34.008 18.416 34.872 17.592 35.624 16.776C36.392 15.96 37 15.168 37.448 14.4C37.912 13.616 38.144 12.856 38.144 12.12C38.144 11.432 37.952 10.824 37.568 10.296C37.2 9.768 36.584 9.504 35.72 9.504C34.84 9.504 34.176 9.792 33.728 10.368C33.28 10.944 33.056 11.64 33.056 12.456H30.08C30.112 11.224 30.384 10.2 30.896 9.384C31.408 8.552 32.088 7.936 32.936 7.536C33.784 7.12 34.736 6.912 35.792 6.912C37.504 6.912 38.832 7.384 39.776 8.328C40.736 9.256 41.216 10.464 41.216 11.952C41.216 12.88 41 13.784 40.568 14.664C40.152 15.544 39.6 16.392 38.912 17.208C38.224 18.024 37.48 18.792 36.68 19.512C35.88 20.216 35.104 20.872 34.352 21.48H41.624V24H30.056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeA12);
export default __webpack_public_path__ + "static/media/age-a12.dc79f13def7789024a5dc0d7d98a4d50.svg";
export { ForwardRef as ReactComponent };